import type { ModuleFile } from '../../core/modules.ts';

// Módulo «home»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'home',
    title: 'Inicio',
    path: 'inicio',
    nav: { group: 'Trabajo', label: 'Inicio', icon: '⌂', order: 1 },
    load: () => import('./HomePage.tsx').then((m) => ({ default: m.HomePage })),
  },
];
